import { Box, styled, Typography, useTheme } from "@mui/material";
import { Container } from "components/container";
import { RetroButton } from "components/RetroButton";
import { RetroCard } from "components/RetroCard";

const Footer = ({
  location,
  footerLogos,
  handleClick,
  ...props
}: {
  location: Location;
  handleClick: (route: string) => void;
  footerLogos: {
    route: string;
    icon: JSX.Element;
    label: string;
  }[];
}) => {
  const theme = useTheme();

  return (
    <Container sx={{ marginY: theme.spacing(1) }} {...props}>
      <RetroCard size="sm">
        <Box
          sx={{
            width: "100%",
            padding: theme.spacing(0.5, 1),
            display: "flex",
            gap: "10px",
            height: "66px",
          }}>
          {footerLogos.map(({ route, icon, label }) => {
            return (
              <RetroButton
                key={route}
                id={route}
                onClick={() => {
                  handleClick(route);
                }}
                disabled={location.pathname === route}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    "& svg": {
                      width: "24px",
                      height: "24px",
                    },
                  }}>
                  {icon}
                  <Typography
                    variant="subtitle"
                    sx={{
                      fontSize: "10px",
                      lineHeight: "9px",
                      marginTop: theme.spacing(0.5),
                    }}>
                    {label}
                  </Typography>
                </Box>
              </RetroButton>
            );
          })}
        </Box>
      </RetroCard>
    </Container>
  );
};

export default Footer;
